/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingQuotaDefinition } from './BillingQuotaDefinition';
import {
    BillingQuotaDefinitionFromJSON,
    BillingQuotaDefinitionFromJSONTyped,
    BillingQuotaDefinitionToJSON,
    BillingQuotaDefinitionToJSONTyped,
} from './BillingQuotaDefinition';

/**
 * 
 * @export
 * @interface BillingQuotaOverride
 */
export interface BillingQuotaOverride {
    /**
     * 
     * @type {number}
     * @memberof BillingQuotaOverride
     */
    billingQuotaDefinitionId: number;
    /**
     * 
     * @type {string}
     * @memberof BillingQuotaOverride
     */
    effectiveFrom: string;
    /**
     * 
     * @type {string}
     * @memberof BillingQuotaOverride
     */
    effectiveTo: string | null;
    /**
     * 
     * @type {number}
     * @memberof BillingQuotaOverride
     */
    value: number;
    /**
     * 
     * @type {BillingQuotaDefinition}
     * @memberof BillingQuotaOverride
     */
    billingQuotaDefinition?: BillingQuotaDefinition;
}

/**
 * Check if a given object implements the BillingQuotaOverride interface.
 */
export function instanceOfBillingQuotaOverride(value: object): value is BillingQuotaOverride {
    if (!('billingQuotaDefinitionId' in value) || value['billingQuotaDefinitionId'] === undefined) return false;
    if (!('effectiveFrom' in value) || value['effectiveFrom'] === undefined) return false;
    if (!('effectiveTo' in value) || value['effectiveTo'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function BillingQuotaOverrideFromJSON(json: any): BillingQuotaOverride {
    return BillingQuotaOverrideFromJSONTyped(json, false);
}

export function BillingQuotaOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingQuotaOverride {
    if (json == null) {
        return json;
    }
    return {
        
        'billingQuotaDefinitionId': json['billingQuotaDefinitionId'],
        'effectiveFrom': json['effectiveFrom'],
        'effectiveTo': json['effectiveTo'],
        'value': json['value'],
        'billingQuotaDefinition': json['billingQuotaDefinition'] == null ? undefined : BillingQuotaDefinitionFromJSON(json['billingQuotaDefinition']),
    };
}

  export function BillingQuotaOverrideToJSON(json: any): BillingQuotaOverride {
      return BillingQuotaOverrideToJSONTyped(json, false);
  }

  export function BillingQuotaOverrideToJSONTyped(value?: BillingQuotaOverride | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billingQuotaDefinitionId': value['billingQuotaDefinitionId'],
        'effectiveFrom': value['effectiveFrom'],
        'effectiveTo': value['effectiveTo'],
        'value': value['value'],
        'billingQuotaDefinition': BillingQuotaDefinitionToJSON(value['billingQuotaDefinition']),
    };
}

